import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const BrandContext = createContext(null);

const FALLBACK = {
  name: "Shubham Bapna", logo_text: "Shubham Bapna", accent_color: "#059669",
  tagline: "Sales growth and business mastery for people who sell a real product.",
  description: "", social: {}, footer_note: "", logo_url: "", favicon_url: "",
};

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState(FALLBACK);
  const load = async () => {
    try { const { data } = await api.get("/brand"); setBrand({ ...FALLBACK, ...data }); }
    catch {}
  };
  useEffect(() => { load(); }, []);
  useEffect(() => {
    document.title = "Shubham Bapna — AI for business owners";
    if (brand?.favicon_url) {
      let link = document.querySelector("link[rel='icon']");
      if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
      link.href = brand.favicon_url;
    }
  }, [brand]);
  return <BrandContext.Provider value={{ brand, reloadBrand: load }}>{children}</BrandContext.Provider>;
}

export const useBrand = () => useContext(BrandContext) || { brand: FALLBACK, reloadBrand: () => {} };
